import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { sortObjectArray } from 'utils/arrayHelpers';
import { makeId } from 'utils/stringHelper';
import { MenuCategory } from './_category';

export const MenuCategories = forwardRef(({ itemData }, ref) => {
  const [categories, setCategories] = useState([]);
  const categoriesRef = useRef({ value: {} }).current;

  useEffect(() => {
    if (itemData?._id) {
      if (itemData.categories) {
        setCategories(itemData.categories);
      }
    }
  }, [itemData]);

  useImperativeHandle(ref, () => ({
    getData() {
      const formedCategories = [];

      Object.values(categoriesRef.value).forEach((categEl) => {
        if (!categEl) {
          return;
        }

        const categoryData = categEl.getData();

        categoryData.order = categories.findIndex((x) => x.category_id === categoryData.category_id);
        formedCategories.push(categoryData);
      });

      sortObjectArray(formedCategories, 'order', 1, true);

      return formedCategories;
    },
  }));

  return (
    <div className="w-full col-span-full">

      <div className="mt-3 mb-6">
        <div>
          <h3 className="text-lg leading-6 font-medium text-gray-900">Categories</h3>
          <p className="mt-1 text-sm text-gray-500">Add some categories to your menu.</p>
        </div>
      </div>

      {categories.map((category, ind) => {
        return (
          <div key={category.category_id} className="mt-6">
            <MenuCategory
              ref={(el) => {
                categoriesRef.value[category.category_id] = el;
              }}
              onRemove={() => {
                categories.splice(ind, 1);
                setCategories([...(categories || [])]);
                categoriesRef.value[category.category_id] = null;
              }}
              itemData={category}
              initData={itemData}
              onOrderUp={ind > 0 ? () => {
                const currentItem = categories[ind];
                const prevItem = categories[ind - 1];

                categories[ind] = prevItem;
                categories[ind - 1] = currentItem;
                setCategories([...(categories || [])]);
              } : undefined}
              onOrderDown={ind < categories.length - 1 ? () => {
                const currentItem = categories[ind];
                const nextItem = categories[ind + 1];

                categories[ind] = nextItem;
                categories[ind + 1] = currentItem;
                setCategories([...(categories || [])]);
              } : undefined}
            />
          </div>
        );
      })}

      <div className="mt-6">
        <button
          type="button"
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md
            text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => {
            setCategories([...(categories || []), { category_id: makeId(10), name: {} }]);
          }}
        >
          Add Category
        </button>
      </div>
    </div>
  );
});
